import type { EdgenModalProps } from "@/src/components/EdgenModal";

/** H5 fullscreen / PC 539×min(852px,90vh) — PC width aligned with LinkSnapTradeModal. */
export const PLAID_IMPORT_MODAL_SHELL_CLASS =
  "[--modal-radius:0px] md:[--modal-radius:24px] [--modal-height:100dvh] md:[--modal-height:min(852px,90vh)] md:[--modal-width:539px] [--modal-width:100%]";

export const plaidImportModalShellProps = (): Pick<
  EdgenModalProps,
  "className" | "contentStyle" | "styles" | "containerStyle" | "titleStyle"
> => ({
  className: PLAID_IMPORT_MODAL_SHELL_CLASS,
  contentStyle: {
    borderRadius: "var(--modal-radius)",
    width: "var(--modal-width)",
    height: "var(--modal-height)",
    overflow: "hidden",
    padding: 0,
  },
  styles: {
    body: {
      height: "100%",
    },
  },
  containerStyle: {
    height: "100%",
    width: "100%",
    maxHeight: "100%",
  },
  titleStyle: {
    minHeight: 0,
  },
});
